import styled from '@emotion/styled';

export const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
